import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { reducer as toastrReducer } from 'react-redux-toastr'

import AppState from './AppStateReducer'
import CurrentSession from './CurrentSessionReducer'
import Drawer from './DrawerReducer'
import Layout from './LayoutReducer'
import Router from './ReduxRouterReducer'

export default (history) => {
  let reducers = {
    router: Router,
    CurrentSession: CurrentSession,
    Layout: Layout,
    AppState: AppState,
    Drawer: Drawer,
    form: formReducer,
    toastr: toastrReducer
  }

  return combineReducers(reducers)
}
